var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsArray, IsDateString, IsNumber, IsObject, IsOptional, IsString, IsUUID, } from 'class-validator';
export class PreventionCourseModuleFullSizeDto {
    id;
    createdAt;
    updatedAt;
    availabilityDaysAfterEnrollment;
    index;
    title;
    description;
    preventionCourseModuleSections;
    preventionCourseId;
    preventionCourse;
    preventionCourseModuleDocuments;
    totalDuration;
    trackings;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PreventionCourseModuleFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionCourseModuleFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionCourseModuleFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], PreventionCourseModuleFullSizeDto.prototype, "availabilityDaysAfterEnrollment", void 0);
__decorate([
    IsNumber(),
    Exclude(),
    __metadata("design:type", Number)
], PreventionCourseModuleFullSizeDto.prototype, "index", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], PreventionCourseModuleFullSizeDto.prototype, "title", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], PreventionCourseModuleFullSizeDto.prototype, "description", void 0);
__decorate([
    IsArray(),
    Expose(),
    __metadata("design:type", Array)
], PreventionCourseModuleFullSizeDto.prototype, "preventionCourseModuleSections", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", String)
], PreventionCourseModuleFullSizeDto.prototype, "preventionCourseId", void 0);
__decorate([
    IsObject(),
    Expose(),
    __metadata("design:type", Function)
], PreventionCourseModuleFullSizeDto.prototype, "preventionCourse", void 0);
__decorate([
    IsArray(),
    Expose(),
    __metadata("design:type", Array)
], PreventionCourseModuleFullSizeDto.prototype, "preventionCourseModuleDocuments", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], PreventionCourseModuleFullSizeDto.prototype, "totalDuration", void 0);
__decorate([
    IsArray(),
    Exclude(),
    __metadata("design:type", Array)
], PreventionCourseModuleFullSizeDto.prototype, "trackings", void 0);
//# sourceMappingURL=prevention-course-module.full-size.dto.js.map